import React from "react";
import { AiOutlineFolder, AiOutlineFolderOpen } from "react-icons/ai";
import { StyledName } from "./Tree.style";

interface FolderNameProps {
  isOpen: boolean;
  name: string;
  handleClick: () => void;
}

export const FolderName = React.memo(({ isOpen, name, handleClick }: FolderNameProps) => {
  console.log('FolderName rendering');
  return (
    <StyledName onClick={handleClick}>
      <div className="colorPrimary" style={{ fontSize: "1.2rem" }}>
        {isOpen ? <AiOutlineFolderOpen /> : <AiOutlineFolder />}
      </div>
      &nbsp;&nbsp;{name}
    </StyledName>
  );
}); 